import { Home } from "lucide-react";
import { Link } from "react-router-dom";

function NotFound({ darkMode }) {
  return (
    <section
      className={`fixed inset-0 z-50 flex min-h-screen items-center justify-center px-6 py-16 ${
        darkMode ? "bg-testora-dark text-white" : "bg-gray-50 text-gray-900"
      }`}
    >
      <div className="max-w-lg text-center">
        <p className="text-8xl font-bold tracking-tight text-purple-500">404</p>
        <h1 className="mt-4 text-3xl font-bold">Page not found</h1>
        <p className={`mt-3 ${darkMode ? "text-gray-400" : "text-gray-600"}`}>
          We couldn&apos;t find the page you were looking for. It may have moved
          or the address may be incorrect.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 rounded-lg bg-purple-600 px-5 py-3 font-semibold text-white transition-colors hover:bg-purple-700"
        >
          <Home size={18} aria-hidden="true" />
          Return to home
        </Link>
      </div>
    </section>
  );
}

export default NotFound;
